// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__17tkT","content":"Consent_content__1rSgA","footer":"Consent_footer__381K7"};